<!--耗材搜索结果页-->

<template>
  <div class="" v-title data-title="药品查询_试剂采购库存管理系统" id="home">
    <ZnBreadcrumb />
    <div class="main-content">
      <div class="search-type" >
        <ul class="clearfix  searchLine">
          <li>
            <el-input type="text" placeholder="请输入耗材名称/货号" v-model="searchValue" @keyup.enter.native="searchQuickly(1)"/>
            <el-button @click="searchQuickly(1)" v-loading.fullscreen.lock="fullscreenLoading">
              搜索
            </el-button>
          </li>
        </ul>
      </div>
      <div class="supplier-sale table-container" id="supplierMaterialsaleId">
        <div class="table-title">
          <span>在售供应商
            <span style="margin-left: 20px;font-size: 15px;color: #606266">截单时间: 每日17点 (周一至周五)</span>
          </span>
          <div class="my-shopping">
            <el-badge :value="myCartNum" class="item" :hidden="myCartNum < 1">
              <button class="cursorPointer"  @click="toMyPurchase">我的选购</button>
            </el-badge>
          </div>
        </div>
        <div class="no-date" v-if="materialGoodsData.length == 0 ">
          <div>
            <img src="../../assets/images/empty.png" alt="" />
            <p>暂无在售供应商</p>
          </div>
        </div>
        <div class="table-content" v-for="(item, index) in materialGoodsData" :key="index" v-else>
          <p class="shop-info" style="background-color:#7F94AF57;height: 30px; line-height: 30px;">
            <span class="code">
              <b>
                <span style="float:left;">
                    <li style="padding-left: 10px;"></li>
                </span>
                <span v-if="item.brandName" style="float:left">{{ item.brandName }}（品牌）
                  <span style="color: red"><span>{{ item.freightDesc }}</span></span>
                </span>
              </b>
            </span>

            <span class="codeEnd" >
              <b>
                <span style="float:left;">
                </span>
                <span style="float:left">{{ item.supplierName }}（供应商）</span>
             </b>
            </span>
          </p>
          <div class="goods-details" id="wfqs">
            <div class="table-details" >
              <el-table
                  :data="item.datas"
                  :cell-style="{padding: '0'}"
                  :row-style="{height: '40px'}"
                  :span-method="(param)=>objectSpanMethod(param,index)"
                  :border=false
                  style="width: 100%;float:right;"
              >

                <el-table-column prop="productName" label="名称"  align="center" min-width="140">
                </el-table-column>
                <el-table-column prop="productNo" label="货号" align="center" max-width="130">
                </el-table-column>



                <el-table-column prop="specifications" label="规格" align="center" min-width="185">
                </el-table-column>

<!--                <el-table-column prop="productDetails" label="详情" align="center" >-->
<!--                </el-table-column>-->

                <el-table-column prop="productDetailsOther" label="其它" align="center" min-width="140">
                </el-table-column>



                <el-table-column prop="packing" label="包装" align="center" width="70"/>
                <el-table-column prop="deliveryTime" label="货期" align="center" max-width="80"/>


                <el-table-column prop="marketPrice" label="售价" align="center" min-width="130">
                  <template slot-scope="scope">
                    <span >
                      <span style="font-size: smaller; text-decoration: line-through;">¥{{ scope.row.schoolPrice }}  </span>
                      <span style="margin-left:5px;color:red;font-size: smaller;font-weight: bold">¥{{ scope.row.discountPrice }}  </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center"  min-width="100">
                  <template slot-scope="scope">
                    <el-badge
                        :value="scope.row.cartNum"
                        class="item"
                        :hidden="scope.row.cartNum < 1"
                    >
                      <el-button
                          type="text"
                          size="small"
                          class="addCart"
                          @click="addChooseBuyBefore(scope.row)"
                      >
                        <div style="display: flex; align-items: center">
                          <img
                              class="carticon"
                              style="
                              width: 14px;
                              height: 14px;
                              display: inline-block;
                              margin-right: 5px;
                            "
                              src="../../assets/images/cart.png"
                              alt=""
                          />
                          <span v-if="scope.row.stockType == 1">
                             <span v-if="scope.row.isBuy == true" style="color: orange">采购期货</span>
                              <span v-else>采购期货</span>
                          </span>
                          <span v-else>
                            <span v-if="scope.row.isBuy == true" style="color: orange">加入选购</span>
                            <span v-else>加入选购</span>
                          </span>
                        </div>
                      </el-button>
                    </el-badge>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- 中文模糊查询展示列表-->
    <el-dialog title="列表" :visible.sync="tableVisible" width="70%">
      <div class="table-container">
        <div >
          <div class="table-title">
            <span>精确查询</span>
          </div>
          <el-table
              :data="tableDataJq"
              :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
              border
              style="width: 100%"
              class="supTable"
          >
            <template slot="empty">
              <p>暂无相关搜索结果</p>
            </template>

            <el-table-column prop="cas" label="CAS号" width="120" >
            </el-table-column>

            <el-table-column prop="cnName" label="中文名">
            </el-table-column>


            <el-table-column prop="enName" label="英文名">
            </el-table-column>

            <el-table-column label="操作" width="80"  >
              <template slot-scope="scope">
                <div style="color:#66b1ff;cursor:pointer" @click="showDeail(scope.row)">
                  选择
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>


        <div class="goods-details">
          <div class="table-title">
            <span>模糊查询</span>
          </div>
          <el-table
              :data="tableData"
              :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
              border
              style="width: 100%"
              class="supTable"
          >
            <template slot="empty">
              <img src="../../assets/images/empty.png" class="empty" />
              <p>暂无相关搜索结果</p>
            </template>

            <el-table-column prop="cas" label="CAS号" width="120" >
            </el-table-column>

            <el-table-column prop="cnName" label="中文名">
            </el-table-column>


            <el-table-column prop="enName" label="英文名">
            </el-table-column>

            <el-table-column label="操作" width="80"  >
              <template slot-scope="scope">
                <div style="color:#66b1ff;cursor:pointer" @click="showDeail(scope.row)">
                  选择
                </div>
              </template>
            </el-table-column>
          </el-table>
          <Pagination
              :dataTotal="dataTotal"
              :totalpage="totalpage"
              :pagesize="searchData.pageSize"
              @changePage="changePage"
          ></Pagination>
        </div>
      </div>
    </el-dialog>



  </div>
</template>
<script>
import axios from "axios";
import { EventBus } from "../../config/event-bus.js";
import elDragDialog from "../../directive/el-dragDialog";
import Calculator from "@/components/calculator";
export default {
  directives: {
    elDragDialog,
  },
  data() {
    return {
      calDialogVisible:false,
      structLoading:null,
      //用户类型 1管理员 2普通用户
      queryType: null,
      coverImg: "",
      goodsId: "",
      myCartNum: "",
      yuYueNum: 0,
      AddCartnum: 1,
      dialogAddCart: false,
      dialogBorrow: false,
      content: "",
      inventoryData: [],
      supplierData: [],
      slowSupplierData:[],
      tansuoSupplierData:[],
      materialGoodsData:[],
      tableArr: [],
      howWidth: 12,
      alias: "",
      borrowGoodsdata: "",
      SpecificationData: "",
      goodSkulist: [],
      specIdsList: "",
      selectSpecInfo: "",
      isSkuDisable: false,
      flagnum: 0,
      //分子式中文名查询
      searchValue:'',
      searchName:'',
      searchType:1,
      currentTaskId:'',
      currentUserId:'',
      currentVersion: null,
      fullscreenLoading: false,
      pictLoading:true,
      itemLoding:"",
      inventoryCas:"",
      tableData:"",
      tableDataJq:"",
      tableVisible:false,
      totalpage: 0,
      dataTotal: 0,
      searchData: {
        alias: "",
        pageNum: 1,
        pageSize: 5,
      },
      isBorrow: 0,
      spanArr: [],
    };
  },
  created() {
    this.searchValue = null;
    localStorage.setItem("test", this.myCartNum);
    if(this.$route.params.goodsName){
      this.searchValue = this.$route.params.goodsName;
    }
    this.myCart();
    this.supplierList();
  },
  mounted() {
  },
  filters: {
    numFilter (value) {
      // 截取当前数据到小数点后三位
      return Math.floor(value*1000)/1000;
    },
  },

  watch: {
  },
  computed:{ // 计算属性

  },
  methods: {
    changeTab(){

    },
    handleClose(){
      this.calDialogVisible = false;
    },
    // 添加搜索记录到库中
    addSearchLog(content){
      try{
        this.$apiFetch
            .post(`/searchLog/add`,{searchContent:content,logType: 1})
            .then(function (res) {
              if(res.data){
                console.log("搜索记录添加成功.",res.data)
              }
            });
      }catch (e) {
        console.log(e)
      }
    },


    // 隐藏第一行 的所有列 也就是 orderList[0]
    // objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
    //   if(columnIndex===0){
    //     if (rowIndex === 0) {
    //       // 将第四列的第2行 跨度到 第999行, 业务显示为 合并状态, 其实从第三行开始的数据还在页面只是被隐藏了
    //       return {rowspan: 999, colspan: 1}
    //     } else {
    //       return {rowspan: 0, colspan: 0}
    //     }
    //   }
    //   // // 除以上情况 其余行列 正常显示
    //   return {rowspan: 1, colspan: 1}
    // },


    getSpanArr(data) {
      data.map((item, idx) => {
        this.spanArr.push([]);
        for (let i = 0; i < item.datas.length; i++) {
          if (i === 0) {
            this.spanArr[idx].push(1)
            this.pos = 0
          } else {
            // 判断当前元素与上一个元素是否相同
            if (item.datas[i].context === item.datas[i - 1].context) {
              this.spanArr[idx][this.pos] += 1
              this.spanArr[idx].push(0)
            } else {
              this.spanArr[idx].push(1)
              this.pos = i
            }
          }
        }
      });
    },

    // objectSpanMethod({ row, column, rowIndex, columnIndex }, idx) {
    //   let spanOneArr = [[]];
    //   this.materialGoodsData.map(goods => {
    //     let concatOne = 0;
    //     goods.datas.map((item, index) => {
    //       if (index === 0) {
    //         spanOneArr[idx].push(1);
    //       } else {
    //         //第一列需合并相同内容的判断条件
    //         if (item.context === goods.datas[index - 1].context) {
    //           spanOneArr[idx][concatOne] += 1;
    //           spanOneArr[idx].push(0);
    //         } else {
    //           spanOneArr[idx].push(1);
    //           concatOne = index;
    //         }
    //       }
    //     });
    //   });
    //   if (columnIndex === 0) {
    //     const _row = spanOneArr[idx][rowIndex];
    //     const _col = _row > 0 ? 1 : 0;
    //     return {
    //       rowspan: _row,
    //       colspan: _col
    //     }
    //   }
    // },
    objectSpanMethod({ row, column, rowIndex, columnIndex }, idx) {
      if (columnIndex === 0) {
        const _row = this.spanArr[idx][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    clearAllData(){
      this.slowSupplierData = [];
      this.tansuoSupplierData = [];
      this.hansiSupplierData = [];
      this.inventoryData=[];
      this.supplierData=[];
      this.tableArr = [];
    },

    //快速查询
    async searchQuickly(type) {
      this.supplierList();
    },

    //在售供应商
    supplierList() {
      let searchValue = this.searchValue;
      if(!searchValue || searchValue == ''){
        return;
      }
      const loading = this.$loading({
        lock:true,
        text:"正在加载",
        spinner:"el-icon-loading",
        background:"#f5f7fac4",
        target:document.querySelector("#supplierMaterialsaleId")
      })
      const data = {};
      data.searchValue = searchValue;
      this.$apiFetch.get('/lockerGoods/materialList',data).then((res) => {
        loading.close();
        this.materialGoodsData = res.data;
        this.spanArr = [];
        this.getSpanArr(this.materialGoodsData);
      }).catch((error) =>{
        loading.close();
        console.log('Request Failed', error)
      })
    },

    //我的选购
    myCart() {
      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        this.myCartNum = res.data;
        localStorage.setItem("test", res.data)
        EventBus.$emit('showCityName',res.data);
      });
    },
    //加入购物车规格信息
    addCartGoodsInfo(row) {
      let id = row.goodsList[0].id;
      this.$apiFetch.get(`/lockerGoods/${id}`).then((res) => {
        this.SpecificationData = res.data;
        this.coverImg = res.data.coverImg;
        this.initspeci(res.data);
        this.dialogAddCart = true;
      });
    },
    // 处理规格数据
    initspeci(data) {
      let newarr = data.goodsSpecRelationList.filter((a) => {
        if (a.pid == 0) return a;
      });
      let newarr2 = data.goodsSpecRelationList.filter((a) => {
        if (a.pid != 0) return a;
      });
      newarr.forEach((item) => {
        item.Spec = [];
        newarr2.forEach((item2) => {
          if (item.specId == item2.pid) {
            item.Spec.push(item2);
          }
        });
      });
      console.log("newArr", newarr);
      this.goodSkulist = newarr;
      this.selectSpecInfo = data.goodsSkuDetailList[0];
      this.setSpecIdsList();
    },
    selectSpec(index, index2) {
      let arr = [];
      let flag = false;
      this.isSkuDisable = false;
      let flagnum = 0;
      this.flagnum = 0;
      this.goodSkulist.forEach((r, i) => {
        r.Spec.forEach((s, c) => {
          if (index == i) {
            if (c == index2) {
              s.select = !s.select;
            } else {
              s.select = false;
            }
          }
          if (s.select) {
            flagnum += 1;
            arr.push(s.specId + "");
            arr.sort();
          }
        });
      });
      if (flagnum == this.goodSkulist.length) {
        this.flagnum = flagnum;
        flag = true;
        // console.log('flagnum',flagnum)
      }
      this.goodSkulist = JSON.parse(JSON.stringify(this.goodSkulist));
      // this.initgoodInfo(arr.toString());
      let arrstr = arr.toString();
      if (this.specIdsList.includes(arrstr)) {
        this.specIndex = this.specIdsList.indexOf(arrstr);
        this.selectSpecInfo =
            this.SpecificationData.goodsSkuDetailList[this.specIndex];
        this.AddCartnum = 1;
        console.log("选择数据", arrstr, this.specIdsList);
      }
      if (flag && !this.specIdsList.includes(arrstr)) {
        this.isSkuDisable = true;
        this.$message.error("该商品规格已被禁用");
      }
    },
    setSpecIdsList() {
      // 处理商品数据
      this.specIdsList = this.SpecificationData.goodsSkuDetailList.map(
          (res) => {
            let c = res.specIds.split(",");
            c.sort();
            return c.toString();
          }
      );
      console.log("specIdsList", this.specIdsList);
    },

    //校验商品
    async checkGoods(params){
      let flag = false;
      let returnFlag = false;
      const res = await this.$apiFetch.post('/lockerShopCart/check', params)
      if(res.status == 200){
        flag = res.data
      }
      return flag;
    },
    //加入选购
    async addChooseBuy(row) {
      console.log("1,"+row);
      if (!row.cartNum) {
        row.cartNum = 0;
      }
      console.log("2,"+row.productDetailsOther);
      var productDetailsOther = "";
      if(!row.productDetailsOther || row.productDetailsOther != undefined){
        productDetailsOther = row.productDetailsOther;
      }
      console.log("3,"+productDetailsOther);
      let params = {
        supplierName: row.supplierName,
        supplierId: row.supplierId,
        specIds: row.productNo,
        goodsId : row.productId,
        num: row.cartNum + 1,
        goodsName : row.productName,
        salesPrice : row.discountPrice,
        specNames : row.specifications,
        specExtension: productDetailsOther,
        weight : 'EA',
        brand : row.brand,
        originPrice:row.isSpecial==1?row.discountPrice:row.schoolPrice,
        isSpecial:row.isSpecial==1?1:0,
        //是否期货，0(正常商品) 为1时：期货，
        isStock: row.stockType,
        casNo: '',
        packageType: row.packing,
        productType: 1
      };
      let flag= await this.checkGoods(params)
      if(flag == true) {
        this.$confirm("购物车中已有该商品，是否确认继续添加", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(()=>{
          this.$apiFetch.post("/lockerShopCart", params).then((res) => {
            console.log(res);
            this.myCart();
            // this.supplierList();
            let alias = this.alias;
            // this.$apiFetch.get(`/lockerGoods/list?alias=${alias}`).then((res) => {
            //   this.supplierData = res.data;
            // }).catch((error) =>{
            //   console.log('Request Failed', error)
            // })
          });
        }).catch((error)=>{})
      }else{
        this.$apiFetch.post("/lockerShopCart", params).then((res) => {
          console.log(res);
          this.myCart();
          let alias = this.alias;

        });
      }
      row.isBuy = true
    },


    async addChooseBuyBefore(row) {

      this.addChooseBuy(row);

    },

    handleChange(value) {
      console.log(value);
      // this.AddCartnum = value
    },
    async changePage(data) {
      this.searchData.pageNum = data;

      let params = this.searchData;
      params.alias = this.alias;
      let resultCas = await this.$apiFetch.get('/lockerCas/queryForCasPage',params);
      this.tableData=resultCas.data.list;
      this.totalpage = resultCas.data.pages;
      this.dataTotal = resultCas.data.total;
      this.tableVisible=true;
      return;
    },
    confirmAddCart(type) {
      // 加入购物车 add 加入购物车 buy 立即购买
      let info = this.selectSpecInfo;
      if (this.flagnum <= 0) {
        this.$message.error("请选择商品规格~");
        return;
      }
      if (this.isSkuDisable) {
        this.$message.error("该商品规格已被禁用,不可下单~");
        return;
      }
      // console.log('info',this.AddCartnum+(info.cartNum?info.cartNum:0),type)
      if (!(this.AddCartnum + info.cartNum)) {
        this.$message.error("数量不能为0");
        return;
      }
      if (info.stock <= 0) {
        this.$message.error("库存不足，不能下单~");
        return;
      }
      this.dialogBorrow = false;
      let params = {
        goodsId: info.goodsId,
        goodsSkuDetailId: info.id,
        num: this.AddCartnum + (info.cartNum > 0 ? info.cartNum : 0),
      };
      this.$apiFetch.post("/lockerShopCart", params).then(() => {
        this.myCart();
        this.supplierList();
        this.slowSupplierList();
        this.tansuoSupplierList();
        //this.hansiSupplierList()();
        if (type == "buy") {
          this.toMyPurchase();
        }
      });
      this.dialogAddCart = false;

      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        this.myCartNum = res.data;
        localStorage.setItem("test", res.data)
        EventBus.$emit('showCityName',res.data);
      });
    },
    toMyPurchase() {
      this.$router.push({ path: "myPurchase" });
    },
  },
};
</script>
<style lang="less" scoped>
.mohu{
  color: transparent; text-shadow: 0 0 5px rgba(0,0,0,0.5);
}
.no-date {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}
.main-content {
  background-color: unset;
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      float: left;
      width: 50%;
      position: relative;
      img {
        width: 14px;
        display: block;
        position: absolute;
        top: 11px;
        left: 9px;
      }
      input {
        //width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }
      button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin: 0 12px;
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  margin-top: 20px;
  background-color: #ffffff;
  .table-title {
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    position: relative;
    padding-left: 11px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f8;
  }
  .table-title::before {
    width: 3px;
    height: 16px;
    background: #478aff;
    content: "";
    position: absolute;
    left: -6px;
    top: 3px;
  }
}
.drugs-details {
  margin-top: 0;
  border-radius: 0 0 4px 4px;
  .box {
    width: 100%;
    min-height: 55px;
    display: flex;
    border-left: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    .content1 {
      // width: 34%;
      width: 220px;
      height: 55px;
      min-width: 230px;
      line-height: 25px;
      padding-left: 20px;
      border-right: 1px solid #e8e8e8;
      color: #666666;
      font-size: 14px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    .content2 {
      .Safety {
        display: flex !important;
        align-items: center;
      }
      &.Syonyms{
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      flex: 1;
      // width: 66%;
      height: 55px;
      line-height: 25px;
      padding-left: 20px;
      font-weight: 600;
      background-color: #fff;
      // border-right: 1px solid #e8e8e8;
      // border-bottom: 1px solid #e8e8e8;
      color: #333333;
      font-size: 14px;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 50px;
        margin-top: 3px;
      }
    }
  }
  .whole-line {
    width: 100%;
    min-height: 55px;

    .content1 {
      width: 220px;
      // width: calc(17% - 4px);
      // border-bottom: 1px solid #e8e8e8;
    }
    .content2 {
      flex: 1;
      width: 83%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}
.supplier-sale {
  .table-title {
    position: relative;
    .my-shopping {
      position: absolute;
      bottom: 9px;
      right: 0;
    }
    button {
      width: 98px;
      height: 36px;
      background: #478aff;
      border-radius: 4px;
      font-size: 12px;
      color: #ffffff;
    }
  }
  .table-content {
    background-color: #f8fafc;
    margin-top: 20px;
    padding: 18px 20px 15px 20px;

    .supplier-info {
      padding-bottom: 18px;

      span {
        font-size: 15px;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
        padding-right: 10px;
      }
      button.consult {
        width: 84px;
        height: 22px;
        background: #478aff;
        border-radius: 11px;
        color: #ffffff;
        font-size: 12px;
      }
      button.choose {
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          color: #478aff;
          font-size: 12px;
          font-weight: 400;
        }
        width: 98px;
        height: 28px;
        border-radius: 4px;
        border: 1px solid #478aff;

        line-height: 18px;
        float: right;
        background-color: #ffffff;
      }
    }
    .shop-info {
      .code {
        color: #333333;
        font-size: 14px;
        padding-left: 14px;
        // position: relative;
      }
      .code::before {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        background: #478aff;
        left: -6px;
        top: 4px;
      }
      .codeEnd {
        color: #333333;
        font-size: 14px;
        padding-left: 14px;
        // position: relative;
        float: right;
      }
      .codeEnd::before {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        background: #478aff;
        left: -6px;
        top: 4px;
      }
      .name {
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
        padding-left: 20px;
      }
    }
    .goods-details {
      padding-top: 15px;
      .goods-box {
        img.left-img {
          float: left;
          width: 172px;
          height: 140px;
          display: block;
          object-fit: contain;
        }
      }

      .table-details {
        padding-left: 16px;
        overflow: hidden;
      }
      .goodsNameCol {
        width:10%;
        height:100%;
        float:left;
      }
      /deep/ .el-table {
        position: inherit;
        overflow: hidden;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        width: 100%;
        max-width: 100%;
        font-size: 14px;
        color: #606266;
      }
      /deep/ .el-table .cell {
        overflow: unset;
        img {
          display: block;
          width: 80px;
        }
      }
      /deep/ .el-table tr {
        background-color: #f8fafc;
      }
      /deep/ .el-table--border td {
        border-color: #d6e1ed;
      }
    }
  }
}
.inventory-library {
  .table-handel {
    float: right;
    span {
      color: #666666;
      font-weight: normal;
      i {
        color: #fa8c16;
      }
    }
    span.to-see {
      padding-left: 24px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
      position: relative;
      padding-right: 16px;
      img {
        position: absolute;
        width: 16px;
        right: 0;
        top: 1;
      }
    }
  }
}
.addCartDia {
  ul.goods-title {
    li {
      line-height: 20px;
      padding-bottom: 25px;
      display: flex;
      flex-wrap: wrap;
      label {
        color: #666666;
        font-size: 14px;
        width: 56px;
        padding-right: 20px;
        display: inline-block;
        line-height: 34px;
        // padding-top: 5px;
        flex-shrink: 0;
      }
      .labelLineHeight{
        line-height: 18px;
      }
      .price {
        color: #fa8c16;
        font-weight: 600;
        line-height: 20px;
        font-size: 14px;
      }
      /deep/.el-input-number__decrease {
        border-right: 1px solid #ffffff;
        .el-icon-minus {
          color: #979797;
          font-weight: 700;
        }
      }
      /deep/ .el-input-number__increase {
        border-left: 1px solid #ffffff;
      }
      /deep/.el-input__inner {
        border: none;
        background-color: #f6f6f6;
        color: #333333;
        font-weight: 700;
      }
      span.repertory {
        padding-left: 10px;
        color: #333333;
        line-height: 34px;
      }
      .specNamelist{
        display: flex;
        flex-wrap: wrap;
        flex: 1 ;
      }
      ul {
        // vertical-align: middle;
        display: flex;
        flex-wrap: wrap;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 78px;
          height: 34px;
          background: #eeeeee;
          border-radius: 4px;
          color: #666666;
          margin-right: 16px;
          padding: 0;
          line-height: 34px;
          text-align: center;
          margin-bottom: 15px;
        }
        .on {
          background: rgba(71, 138, 255, 0.8);
          color: #fff;
        }
        li:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
  img {
    width: 194px;
    height: 194px;
    object-fit: contain;
    display: block;
    float: left;
    margin-right: 30px;
    border-radius: 4px;
  }
  .goods-info {
    overflow: hidden;
  }
}
.el-dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding: 0 20px;
  }
  .el-dialog__title {
    font-weight: 700;
  }
  .el-button {
    border-color: #478aff;
    color: #478aff;
  }
  .el-button--primary {
    background-color: #478aff;
    color: #ffffff !important;
  }
}
/deep/ .el-popover {
  text-align: center;
  color: #333333;
  font-size: 18px;
  font-weight: 700;
  padding: 24px;
}
/deep/ .el-popover__title {
  color: #999999;
  font-size: 14px;
  font-weight: normal;
}
.borrowDia {
  ul {
    li {
      padding-top: 20px;
      label {
        display: block;
        color: #666666;
        font-size: 14px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }
      .tips {
        font-size: 12px;
        line-height: 18px;
        color: #999999;
        padding-top: 6px;
        display: block;
      }
    }
    li:first-child {
      padding-top: 0;
    }
    li:last-child {
      input {
        border-bottom: 1px dashed #cccccc;
      }
    }
  }
}



.message-text{
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}
.fontblack{
  color:#999999
}
.img2{
  width: .81rem;
  height: .8rem;
  float: right;
}
.addressshow2{
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 75%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  font-size: 1rem;
}
.addressshow1{
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 75%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  font-size: 1rem;
}
.orderTitle{
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}
.orderDetail{
  font-size: 0.8rem;
  color: #666666;
  text-align:left;
}
.border-ceter{
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}
.pay-button{
  width: 88%;
  height: 2.6rem;
  position:relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}
ul li{
  list-style:none;
  font-size: 1rem;
}
ul {
  padding-left: 1.5rem
}
.track-list{
  position:relative;
}
.track-list li{
  position:relative;
  padding:0px 0 1.5rem 25px;
  line-height:1rem;
  border-left:1px solid #d9d9d9;
  color: #999;
}
.track-list li.first{
  color:red;
  padding-top:0;
  width: 100%;
  text-align: left;
  border-left:1px solid #d9d9d9;
}
.track-list li .node-icon{
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top:4px;
  background-color: #999999;
}
.track-list li.first .node-icon{
  background-position:0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}
.track-list li .time{
  margin-right:20px;
  position:relative;
  top:4px;
  display:inline-block;
  vertical-align:middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}
.track-list li .txt{
  position:relative;
  display:inline-block;
  vertical-align:top;
  color: #999;
}
.track-list li.first .time{
  text-align: left;
  width: 94%;
  color:red;
}
.track-list li.first .txt{
  color: red;
  text-align: left;
  width: 94%;
}
.track-list li.finall{
  position:relative;
  padding:0px 0 1.5rem 25px;
  line-height:18px;
  border-color: white;
  border-left:1px solid #ffffff;
  color: #999;
}
.track-list li.finall .div-spilander{
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}
</style>

<style scoped>
.el-form-item{
  margin-bottom: 0px;
}
</style>
<style lang="less">
.table-details .el-table td, .table-details .el-table th.is-leaf {
  border-bottom: 1px solid #0a0a0a;
}
.el-notification.right {
  border-left: 5px solid #00ca00;
  width: 478px;
  height: 136px;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  background: url("../../assets/images/successBor.png") no-repeat 39px center;
  background-color: #ffffff;
  box-sizing: border-box;
  background-size: 64px;
  .el-notification__title {
    padding: 26px 0px 0 109px;
    color: #333333;
    font-size: 18px;
  }
  .el-notification__content p {
    padding-left: 109px;
    color: #999999;
    font-size: 16px;
  }
}
.jsme-li {
  display: flex;
  align-items: center;
  position: absolute;
  .jsme-div {
    display: flex;
    align-items: center;
    flex:1;
    //width: 380px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    font-size: 12px;
    color: #cccccc;
    line-height: 18px;
    img {
      width: 14px;
      height: 14px;
      display: block;
      margin: 0 11px;
      position: static !important;
      // top: 11px;
      // left: 9px;
    }
  }
  .jsme-box {
    position: absolute;
    top: 50px;
    left: -150px;
    width: 730px;
    height: 430px;
    // background: #ccc;
    border: 1px solid #ccc;
    z-index: 99;
  }
}
.dialog-footer-button {
  display: inline-block !important;
  width: 98px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #478aff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  margin-right: 16px;
  color: #478aff;
}
/deep/.addCart {
  display: flex;
  .carticon {
    width: 14px !important;
    height: 14px !important;
  }
}
input:disabled {
  background: transparent !important;
}

.h-hundred{
  height: 100%;
}

.tableLeftTextBox{
  height: 100%;
  min-height: 55px;
  padding-left: 20px;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;

}

.tableRightTextBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  font-weight: 700;
  padding: 0 20px;
}

.tableImagesBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.tableRightImgBox{
  height: 275px;
  padding: 20px;


  .text{
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
  }
}

.tabelBl{
  border-left: 1px solid #E8E8E8;
}

.tabelBTr{
  border-top: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
}

.tabelBr{
  border-right: 1px solid #E8E8E8;
}

.tableBB{
  border-bottom: 1px solid #E8E8E8;
}

.textOverflow2{
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.tableImgBox{
  display: inline-block;
  position: relative;

  i.fangda{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #478AFF;
  }
}

.searchLine{
  display: flex;
  align-items: center;

  li{
    flex:1;
    display: flex;

    input{
      flex:1;
    }

  }
}
.tableTitle {
  position: relative;
  margin: 10 auto;
  width: 100%;
  height: 1px;
  background-color: #0a0a0a;
  text-align: center;
  font-size: 16px;
  color: rgba(101, 101, 101, 1);
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
}
.hover-pointer:hover {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
}
.flex-item {
  flex-grow: 1;
  max-width: calc(20% - 20px); /* 前提是5个卡片之间有10像素的间距 */
}
.card-with-image {
  height: 100%;
  width: 100%;
  background-position: center;
  background-size: cover;
}
</style>
